<template>
  <el-dialog
    title="查看库存调整"
    :visible.sync="dialogVisible"
    width="1080px"
    custom-class="inventory-check-adjust-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="adjust-meta" v-if="meta.adjustPlanId || meta.planId">
      <span v-if="meta.planId">盘库单号：{{ meta.planId }}</span>
      <span v-if="meta.planDate">计划日期：{{ meta.planDate || "-" }}</span>
      <span>调整单号：{{ meta.adjustPlanId || "-" }}</span>
      <span v-if="meta.adjustStatusLabel">状态：{{ meta.adjustStatusLabel }}</span>
      <span v-if="meta.sourceTypeLabel">来源：{{ meta.sourceTypeLabel }}</span>
      <span v-if="meta.productTypeSummary">范围：{{ meta.productTypeSummary || "-" }} / {{ meta.purchaseColorSummary || "-" }}</span>
    </div>

    <div v-if="!loading && !tableData.length" class="adjust-empty">{{ emptyTip }}</div>

    <el-table
      v-else
      :data="tableData"
      border
      stripe
      size="mini"
      max-height="420"
      v-loading="loading"
      show-summary
      :summary-method="getSummaries"
    >
      <el-table-column label="序号" width="55" align="center">
        <template slot-scope="scope">{{ scope.row.rowNo || scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="shopName" label="店铺" width="70" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseColorName" label="采购颜色" width="90" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sku" label="SKU" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="bookQty" label="账面" width="70" align="right"></el-table-column>
      <el-table-column prop="checkQty" label="盘点" width="70" align="right"></el-table-column>
      <el-table-column prop="adjustQty" label="调整数量" width="90" align="right">
        <template slot-scope="scope">
          <span :class="{ 'qty-gain': scope.row.adjustQty > 0, 'qty-loss': scope.row.adjustQty < 0 }">
            {{ scope.row.adjustQty }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="方向" width="70" align="center">
        <template slot-scope="scope">
          <span :class="{ 'qty-gain': scope.row.adjustQty > 0, 'qty-loss': scope.row.adjustQty < 0 }">
            {{ formatDirection(scope.row.adjustQty) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="偏差备注" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.remark || "-" }}</template>
      </el-table-column>
    </el-table>

    <div class="adjust-summary" v-if="meta.hasAdjust">
      <span>行数：{{ total }}</span>
      <span>调整合计：{{ meta.totalAdjustQty != null ? meta.totalAdjustQty : "-" }}</span>
      <span v-if="meta.createUser">创建人：{{ meta.createUser }}</span>
      <span v-if="meta.createTime">创建时间：{{ formatTime(meta.createTime) }}</span>
    </div>

    <div class="adjust-pagination" v-if="total > pageSize">
      <el-pagination
        layout="prev, pager, next"
        background
        prev-text="上一页"
        next-text="下一页"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :total="total"
        @current-change="onPageChange"
      ></el-pagination>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="dialogVisible = false">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import request from "../../request/requestModules.js";

export default {
  name: "InventoryCheckAdjustDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      meta: {},
      inventoryCheckId: "",
      adjustId: "",
      fetchMode: "check", // check | adjust
      currentPage: 1,
      pageSize: 50,
      total: 0,
      emptyTip: "该盘库无库存调整",
    };
  },
  methods: {
    open(row) {
      if (!row || !(row.id || row._id)) {
        this.$message.warning("请选择盘库计划");
        return;
      }
      this.fetchMode = "check";
      this.adjustId = "";
      this.inventoryCheckId = String(row.id || row._id);
      this.dialogVisible = true;
      this.currentPage = 1;
      this.meta = {
        planId: row.planId || "",
        planDate: row.planDate || "",
        adjustPlanId: row.adjustPlanId || "",
        productTypeSummary: row.productTypeSummary || "",
        purchaseColorSummary: row.purchaseColorSummary || "",
        hasAdjust: false,
      };
      this.loadPage();
    },
    openByAdjustId(adjustId) {
      const id = String(adjustId || "").trim();
      if (!id) {
        this.$message.warning("请指定库存调整单");
        return;
      }
      this.fetchMode = "adjust";
      this.inventoryCheckId = "";
      this.adjustId = id;
      this.dialogVisible = true;
      this.currentPage = 1;
      this.meta = {
        planId: "",
        planDate: "",
        adjustPlanId: "",
        hasAdjust: false,
      };
      this.loadPage();
    },
    handleClose() {
      this.tableData = [];
      this.meta = {};
      this.inventoryCheckId = "";
      this.adjustId = "";
      this.fetchMode = "check";
      this.total = 0;
      this.currentPage = 1;
      this.emptyTip = "该盘库无库存调整";
    },
    onPageChange(page) {
      this.currentPage = page;
      this.loadPage();
    },
    formatDirection(qty) {
      const n = Number(qty);
      if (n > 0) return "盘盈";
      if (n < 0) return "盘亏";
      return "-";
    },
    formatSourceType(sourceType) {
      if (sourceType === "manual") return "手工调整";
      if (sourceType === "inventoryCheck") return "盘库确认";
      return sourceType || "-";
    },
    formatTime(ts) {
      if (!ts) return "";
      const d = new Date(Number(ts));
      if (Number.isNaN(d.getTime())) return "";
      const pad = n => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    loadPage() {
      if (this.fetchMode === "adjust") {
        if (!this.adjustId) return;
      } else if (!this.inventoryCheckId) {
        return;
      }
      this.loading = true;
      const beginIndex = (this.currentPage - 1) * this.pageSize;
      const req =
        this.fetchMode === "adjust"
          ? request.fetchInventoryAdjust({
              id: this.adjustId,
              beginIndex,
              pageSize: this.pageSize,
            })
          : request.fetchInventoryCheckAdjust({
              id: this.inventoryCheckId,
              beginIndex,
              pageSize: this.pageSize,
            });
      req
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "获取库存调整失败");
            this.tableData = [];
            this.total = 0;
            this.emptyTip = res.message || "获取库存调整失败";
            return;
          }
          this.tableData = res.ldata || [];
          this.total = res.total || 0;
          if (res.mdata) {
            this.meta = {
              ...this.meta,
              ...res.mdata,
              hasAdjust: !!res.mdata.hasAdjust,
              sourceTypeLabel: this.formatSourceType(res.mdata.sourceType),
            };
          }
          if (!this.tableData.length) {
            this.emptyTip = this.meta.hasAdjust ? "暂无调整明细" : "该盘库无偏差，未生成库存调整单";
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取库存调整失败");
          this.tableData = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "adjustQty") {
          sums[index] = (data || []).reduce((s, row) => s + (Number(row.adjustQty) || 0), 0);
          return;
        }
        if (column.property === "bookQty" || column.property === "checkQty") {
          sums[index] = (data || []).reduce((s, row) => s + (Number(row[column.property]) || 0), 0);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
  },
};
</script>

<style lang="scss">
.inventory-check-adjust-dialog {
  .adjust-meta {
    margin-bottom: 10px;
    font-size: 13px;
    color: #606266;
    span {
      margin-right: 16px;
    }
  }
  .adjust-summary {
    margin-top: 8px;
    font-size: 13px;
    color: #606266;
    span {
      margin-right: 16px;
    }
  }
  .adjust-pagination {
    margin-top: 10px;
    text-align: right;
  }
  .adjust-empty {
    padding: 40px 0;
    text-align: center;
    color: #909399;
    font-size: 13px;
  }
  .qty-gain {
    color: #67c23a;
  }
  .qty-loss {
    color: #f56c6c;
  }
}
</style>
